import Label from '@/components/Label/Label';
import Avatar from '@/components/Avatar/Avatar';
import Avatars from '@/components/Avatars';
import Highlight from '@/components/Highlight';
import LabelList from '@/components/LabelList';

export default {
  name: 'TableCell',
  components: {
    Label,
    Avatar,
    Avatars,
    Highlight,
    LabelList
  },
  props: ['type', 'primary', 'secondary', 'shouldHighlight'],
  data() {
    return {};
  },
  computed: {
    isText: function() {
      return this.type === 'Default';
    },

    isAvatar: function() {
      return this.type === 'Avatar';
    },

    isAvatarText: function() {
      return this.type === 'AvatarText';
    },

    isAvatarMulti: function() {
      return this.type === 'AvatarMulti';
    },

    isLabelList: function() {
      return this.type === 'LabelList';
    },

    isLabelListColor: function() {
      return this.type === 'LabelListColor';
    },

    isMultiLine: function() {
      return this.type === 'MultiLine';
    }
  },
  methods: {
    namesOnly(original) {
      return original.map(item => {
        return item.name;
      });
    }
  }
};
